/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

export const CANDIDATE_REFERRER_FETCH = gql`
  query candidateReferrerFetch( $search: SearchFilterInput ) {
    candidate {
      referrers( page: 1 limit: 30 search: $search ) {
        collection {
          id
          createdAt
          deactivatedAt
          email
          firstName
          isActive
          lastName
          referrerType
          referrerUrl
          token
          customFields
        }
      }
    }
  }
`;
